// FETCH ALL FABRIC PO DETAILS
export const FETCH_FABRIC_PO_DETAILS_REQUEST = 'FETCH_FABRIC_PO_DETAILS_REQUEST';
export const FETCH_FABRIC_PO_DETAILS_SUCCESS = 'FETCH_FABRIC_PO_DETAILS_SUCCESS';
export const FETCH_FABRIC_PO_DETAILS_FAILURE = 'FETCH_FABRIC_PO_DETAILS_FAILURE';

export const FETCH_FABRIC_PO_UPDATE_LIST_REQUEST = 'FETCH_FABRIC_PO_UPDATE_LIST_REQUEST';
export const FETCH_FABRIC_PO_UPDATE_LIST_SUCCESS = 'FETCH_FABRIC_PO_UPDATE_LIST_SUCCESS';
export const FETCH_FABRIC_PO_UPDATE_LIST_FAILURE = 'FETCH_FABRIC_PO_UPDATE_LIST_FAILURE';

// FETCH ALL FABRIC PO DETAILS
export const FETCH_FABRIC_PO_DETAILS_WITHOUT_ID_REQUEST = 'FETCH_FABRIC_PO_DETAILS_WITHOUT_ID_REQUEST';
export const FETCH_FABRIC_PO_DETAILS_WITHOUT_ID_SUCCESS = 'FETCH_FABRIC_PO_DETAILS_WITHOUT_ID_SUCCESS';
export const FETCH_FABRIC_PO_DETAILS_WITHOUT_ID_FAILURE = 'FETCH_FABRIC_PO_DETAILS_WITHOUT_ID_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_FABRIC_PO_DETAILS_GROUP_LIST_REQUEST = 'FETCH_FABRIC_PO_DETAILS_GROUP_LIST_REQUEST';
export const FETCH_FABRIC_PO_DETAILS_GROUP_LIST_SUCCESS = 'FETCH_FABRIC_PO_DETAILS_GROUP_LIST_SUCCESS';
export const FETCH_FABRIC_PO_DETAILS_GROUP_LIST_FAILURE = 'FETCH_FABRIC_PO_DETAILS_GROUP_LIST_FAILURE';

export const CREATE_USER_FORM_FABRIC_PO_GENERATE_QTY = 'CREATE_USER_FORM_FABRIC_PO_GENERATE_QTY';

// CREATE FABRIC PO DETAILS
export const CREATE_FABRIC_PO_DETAILS_REQUEST = 'CREATE_FABRIC_PO_DETAILS_REQUEST';
export const CREATE_FABRIC_PO_DETAILS_SUCCESS = 'CREATE_FABRIC_PO_DETAILS_SUCCESS';
export const CREATE_FABRIC_PO_DETAILS_FAILURE = 'CREATE_FABRIC_PO_DETAILS_FAILURE';

// UPDATE FABRIC PO DETAILS
export const UPDATE_FABRIC_PO_DETAILS_REQUEST = 'UPDATE_FABRIC_PO_DETAILS_REQUEST';
export const UPDATE_FABRIC_PO_DETAILS_SUCCESS = 'UPDATE_FABRIC_PO_DETAILS_SUCCESS';
export const UPDATE_FABRIC_PO_DETAILS_FAILURE = 'UPDATE_FABRIC_PO_DETAILS_FAILURE';

// FETCH SINGLE STATE OF FABRIC PO DETAILS
export const FETCH_SINGLE_FABRIC_PO_DETAILS_REQUEST = 'FETCH_SINGLE_FABRIC_PO_DETAILS_REQUEST';
export const FETCH_SINGLE_FABRIC_PO_DETAILS_SUCCESS = 'FETCH_SINGLE_FABRIC_PO_DETAILS_SUCCESS';
export const FETCH_SINGLE_FABRIC_PO_DETAILS_FAILURE = 'FETCH_SINGLE_FABRIC_PO_DETAILS_FAILURE';

// DELETE FABRIC PO DETAILS
export const DELETE_FABRIC_PO_DETAILS_REQUEST = 'DELETE_FABRIC_PO_DETAILS_REQUEST';
export const DELETE_FABRIC_PO_DETAILS_SUCCESS = 'DELETE_FABRIC_PO_DETAILS_SUCCESS';
export const DELETE_FABRIC_PO_DETAILS_FAILURE = 'DELETE_FABRIC_PO_DETAILS_FAILURE';

export const RESET_FABRIC_PO_DETAILS_INFO = 'RESET_FABRIC_PO_DETAILS_INFO';

export const CREATE_FABRIC_PO_DETAILS_FORM = 'CREATE_FABRIC_PO_DETAILS_FORM';

export const UPDATE_FABRIC_PO_DETAILS_FORM = 'UPDATE_FABRIC_PO_DETAILS_FORM';

export const FETCH_FABRIC_PO_PREVIOUS_LIST_REQUEST = 'FETCH_FABRIC_PO_PREVIOUS_LIST_REQUEST';
export const FETCH_FABRIC_PO_PREVIOUS_LIST_SUCCESS = 'FETCH_FABRIC_PO_PREVIOUS_LIST_SUCCESS';
export const FETCH_FABRIC_PO_PREVIOUS_LIST_FAILURE = 'FETCH_FABRIC_PO_PREVIOUS_LIST_FAILURE';

export const FABRIC_PO_DETAILS_USERFORM_SELECTED_ROWS = 'FABRIC_PO_DETAILS_USERFORM_SELECTED_ROWS';

export const CHECK_ALL_UPDATE_REQUEST_FABRIC = 'CHECK_ALL_UPDATE_REQUEST_FABRIC';
export const CHECK_ALL_UPDATE_SUCCESS_FABRIC = 'CHECK_ALL_UPDATE_SUCCESS_FABRIC';
export const CHECK_ALL_UPDATE_FALIURE_FABRIC = 'CHECK_ALL_UPDATE_FALIURE_FABRIC';

export const CLOSE_BTN_POST_REQUEST_FABRIC = 'CLOSE_BTN_POST_REQUEST_FABRIC';
export const CLOSE_BTN_POST_SUCCESS_FABRIC = 'CLOSE_BTN_POST_SUCCESS_FABRIC';
export const CLOSE_BTN_POST_FALIURE_FABRIC = 'CLOSE_BTN_POST_FALIURE_FABRIC';

export const RESET_STATE_FABRIC_SELECTED_DATA = 'RESET_STATE_FABRIC_SELECTED_DATA';

export const FETCH_DIA_DETAILS_DIA_FROM_STYLE_REQUEST = 'FETCH_DIA_DETAILS_DIA_FROM_STYLE_REQUEST';
export const FETCH_DIA_DETAILS_DIA_FROM_STYLE_SUCCESS = 'FETCH_DIA_DETAILS_DIA_FROM_STYLE_SUCCESS';
export const FETCH_DIA_DC_DETAILS_DIA_FROM_STYLE_FAILURE = 'FETCH_DIA_DC_DETAILS_DIA_FROM_STYLE_FAILURE';



export const FETCH_GAUGE_DETAILS_GAUGE_FROM_STYLE_REQUEST = 'FETCH_GAUGE_DETAILS_GAUGE_FROM_STYLE_REQUEST';
export const FETCH_GAUGE_DETAILS_GAUGE_FROM_STYLE_SUCCESS = 'FETCH_GAUGE_DETAILS_GAUGE_FROM_STYLE_SUCCESS';
export const FETCH_GAUGE_DETAILS_GAUGE_FROM_STYLE_FAILURE = 'FETCH_GAUGE_DETAILS_GAUGE_FROM_STYLE_FAILURE';


export const FETCH_LOOP_DETAILS_LOOPLENGTH_FROM_STYLE_REQUEST = 'FETCH_LOOP_DETAILS_LOOPLENGTH_FROM_STYLE_REQUEST';
export const FETCH_LOOP_DETAILS_LOOPLENGTH_FROM_STYLE_SUCCESS = 'FETCH_LOOP_DETAILS_LOOPLENGTH_FROM_STYLE_SUCCESS';
export const FETCH_LOOP_DETAILS_LOOPLENGTH_FROM_STYLE_FAILURE = 'FETCH_LOOP_DETAILS_LOOPLENGTH_FROM_STYLE_FAILURE';




export const FETCH_CURRENT_RATE_FROM_STYLE_REQUEST = 'FETCH_CURRENT_RATE_FROM_STYLE_REQUEST';
export const FETCH_CURRENT_RATE_FROM_STYLE_SUCCESS = 'FETCH_CURRENT_RATE_FROM_STYLE_SUCCESS';
export const FETCH_CURRENT_RATE_FROM_STYLE_FAILURE = 'FETCH_CURRENT_RATE_FROM_STYLE_FAILURE';

export const EDIT_API_SELECTED_ROWS_CALL_REQUEST = 'EDIT_API_SELECTED_ROWS_CALL_REQUEST';
export const EDIT_API_SELECTED_ROWS_CALL_SUCCESS = 'EDIT_API_SELECTED_ROWS_CALL_SUCCESS';
export const EDIT_API_SELECTED_ROWS_CALL_FAILURE = 'EDIT_API_SELECTED_ROWS_CALL_FAILURE';


export const PREVLIST_LOADER_INDICATION = 'PREVLIST_LOADER_INDICATION'
export const RESET_FABRIC_PO_DETAILS_LIST = 'RESET_FABRIC_PO_DETAILS_LIST'



